import { useEffect, useState } from 'react';
import {
  collection,
  onSnapshot,
  type Unsubscribe,
} from 'firebase/firestore';
import { getFirebaseFirestore } from '../firebase/index';
import type { FacebookPageConnection, InstagramAccountConnection } from '../types';
import type { Timestamp } from 'firebase/firestore';

interface WorkspaceIntegrationsState {
  facebookPages: FacebookPageConnection[];
  instagramAccounts: InstagramAccountConnection[];
  loading: boolean;
}

const defaultState: WorkspaceIntegrationsState = {
  facebookPages: [],
  instagramAccounts: [],
  loading: false,
};

const mapTimestamp = (value: unknown): Date | null => {
  if (!value) {
    return null;
  }
  if (value instanceof Date) {
    return value;
  }
  if (typeof value === 'string') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  if (typeof value === 'number') {
    return new Date(value);
  }
  const firestoreTimestamp = value as Timestamp;
  if (typeof firestoreTimestamp.toDate === 'function') {
    return firestoreTimestamp.toDate();
  }
  return null;
};

const requiresReauthorization = (expiresAt: Date | null): boolean => {
  if (!expiresAt) {
    return false;
  }
  const bufferMs = 24 * 60 * 60 * 1000; // 24 hours
  return expiresAt.getTime() <= Date.now() + bufferMs;
};

export const useWorkspaceIntegrations = (workspaceId: string | null): WorkspaceIntegrationsState => {
  // Stubbed for Local Dev to prevent Firebase Permission Errors
  // TODO: Implement API-based integrations fetch
  return defaultState;
};
